import Constants, { ServiceAPI } from '../utils/Constants';
import ServiceBase from './ServiceBase';
import HoseModel from '../model/HoseModel';
import HoseHistoryModel from '../model/HoseHistoryModel';

export default class HoseManagementService extends ServiceBase {

    /**
     * 
     */
    getHoses = () => {
      let url = Constants.ServiceAPI.HoseManagementUrl;

      let packet = this.buildRequestPacket(Constants.Http.Method.GET);

      return fetch(url, packet).then(this.convertResponseToJson).then(json => {
        let hoseModels = [];
        
        json.map( (hose) => {
          hoseModels.push(new HoseModel( hose ));
        });
        
        return hoseModels;
      });
    }

    /**
     * Get a single hose record based on the supplied Id value
     * @param {int} id 
     * @returns 
     */
    getHose = (id) => {
      let url = this.getServiceUrl(Constants.ServiceAPI.HoseManagementUrl, id);

      let packet = this.buildRequestPacket(Constants.Http.Method.GET);

      return fetch(url, packet).then(this.convertResponseToJson).then(json => {
        return new HoseModel( json );
      });
    }

    /**
     * 
     * @param {*} hoseModel 
     * @returns 
     */
    createHose = (hoseModel) => {
      if (hoseModel?.getType() != 'HoseModel') {
        console.warn("Passed variable type that is not a HoseModel to HoseManagementService.createHose()");
        return; // Cant save anything other than a HoseModel.
      }

      let url = this.getServiceUrl(Constants.ServiceAPI.HoseManagementUrl);

      let packet = this.buildRequestPacket(Constants.Http.Method.POST, hoseModel);

      return fetch(url, packet).then(this.convertResponseToJson).then(json => {
        console.log("hoseCreate: ", json);
        return json;
      });
    }

    /**
     * 
     * @param {*} hose 
     * @returns 
     */
    updateHose = (hoseModel) => {
      if (hoseModel?.getType() != 'HoseModel') {
        console.warn("Passed variable type that is not a HoseModel to HoseManagementService.updateHose()");
        return; // Cant save anything other than a HoseModel.
      }

      let url = this.getServiceUrl(Constants.ServiceAPI.HoseManagementUrl);

      let packet = this.buildRequestPacket(Constants.Http.Method.PUT, hoseModel);

      return fetch(url, packet).then(this.convertResponseToJson).then(json => {
        return json;
      });
    }

    /**
     * 
     * @param {*} hoseId 
     * @returns 
     */
    deleteHose = (hoseId) => {
      let url = this.getServiceUrl(Constants.ServiceAPI.HoseManagementUrl);

      let packet = this.buildRequestPacket(Constants.Http.Method.DELETE, {id: hoseId});

      return fetch(url, packet).then(this.convertResponseToJson).then(json => {
        return json;
      });
    }
 
    
    /**
     * 
     * @param {HoseTestModel} testRecord 
     */
    createHoseTest = (testRecord) => {
      if (testRecord?.getType() != 'HoseTestModel') {
        console.warn("Passed variable type that is not a HoseTestModel to HoseManagementService.createHoseTest()");
        return; // Cant save anything other than a HoseTestModel.
      }

      let url = this.getServiceUrl(Constants.ServiceAPI.HoseTestUrl);

      let packet = this.buildRequestPacket(Constants.Http.Method.POST, testRecord);

      return fetch(url, packet).then(this.convertResponseToJson).then(json => {
        return json;
      });
    }


    /**
     * Get the history details for a supplied hose id.
     * @param {int} hoseId 
     */
    getHoseHistory = (hoseId) => {
      let url = this.getServiceUrl(Constants.ServiceAPI.HoseHistoryUrl, hoseId);

      let packet = this.buildRequestPacket(Constants.Http.Method.GET);

      return fetch(url, packet).then(this.convertResponseToJson).then(json => {
        return new HoseHistoryModel(json);
      });
    }
}